import { dataProvider } from '../../firebase';
import { IConfigs } from '../../types';

export const CONFIGS_UNIQUE_ENTRY_ID = '1';
const RESOURCE = 'configs';

export const initConfigs = async () => {
  console.log(`Initializing ${RESOURCE}...`);
  let current;
  try {
    current = (await dataProvider.getOne(RESOURCE, { id: CONFIGS_UNIQUE_ENTRY_ID })).data as IConfigs;
    console.log('Got current ', { RESOURCE, CONFIGS_UNIQUE_ENTRY_ID, current });
    // TODO: Uncoment after development
    // if (current) {
    //   return;
    // }
  } catch (e) {
    console.log('Cant get current (and thats OK)', { RESOURCE, CONFIGS_UNIQUE_ENTRY_ID });
    // do nothing: fails because doesnt exist
  }
  const record: IConfigs = {
    id: CONFIGS_UNIQUE_ENTRY_ID,
    congress_name: '',
    congress_url: '',
    // Empty by default: every entry falls back to the label hardcoded in the app.
    menu: {},
    // Empty by default: the app falls back to its own wording.
    otaUpdateMessage: '',
    share_title: '',
    export_title: '',
    image_1: {
      title: '',
      src: '',
    },
    image_2: {
      title: '',
      src: '',
    },
    image_3: {
      title: '',
      src: '',
    },
    image_4: {
      title: '',
      src: '',
    },
    image_5: {
      title: '',
      src: '',
    },
    image_6: {
      title: '',
      src: '',
    },
    image_7: {
      title: '',
      src: '',
    },
    image_psic: {
      title: '',
      src: '',
    },
    image_neur: {
      title: '',
      src: '',
    },
    image_psic_iconDrawer: {
      title: '',
      src: '',
    },
    image_neur_iconDrawer: {
      title: '',
      src: '',
    },
    image_psic_iconMain: {
      title: '',
      src: '',
    },
    image_neur_iconMain: {
      title: '',
      src: '',
    },
    export_item_title: '',
    color_primary_50: '',
    color_primary_100: '',
    color_primary_200: '',
    color_primary_300: '',
    color_primary_400: '',
    color_primary_500: '',
    color_primary_600: '',
    color_primary_700: '',
    color_primary_800: '',
    color_primary_900: '',
    color_secondary_50: '',
    color_secondary_100: '',
    color_secondary_200: '',
    color_secondary_300: '',
    color_secondary_400: '',
    color_secondary_500: '',
    color_secondary_600: '',
    color_secondary_700: '',
    color_secondary_800: '',
    color_secondary_900: '',
    ...current,
  };
  if (current) {
    await dataProvider.update(RESOURCE, {
      id: CONFIGS_UNIQUE_ENTRY_ID,
      data: record,
      previousData: current,
    });
  } else {
    await dataProvider.create(RESOURCE, { data: record });
  }

  console.log(`Initializing ${RESOURCE}... done`);
};
